import {
  FETCH_USER_ROLE, FETCH_USER_ROLE_SUCCEEDED, FETCH_USER_ROLE_FAILED,
  FETCH_USER_ROLES, FETCH_USER_ROLES_SUCCEEDED, FETCH_USER_ROLES_FAILED, 
  CREATE_USER_ROLE, CREATING_USER_ROLE_SUCCEEDED, CREATING_USER_ROLE_FAILED,
  UPDATE_USER_ROLE, UPDATING_USER_ROLE_SUCCEEDED, UPDATING_USER_ROLE_FAILED,
  DELETE_USER_ROLE, DELETING_USER_ROLE_SUCCEEDED, DELETING_USER_ROLE_FAILED
} from 'constants/actionTypes.jsx';

import { call, put, takeLatest } from 'redux-saga/effects';
import axios from 'axios';
import { createAction } from 'redux-actions';
import buildUrl from 'build-url';

const apiUrl = process.env.REACT_APP_PAPERFLITE_API_URL;
const cleverstoryApiUrl = process.env.REACT_APP_CLEVERSTORY_API_URL;

const USER_ROLES_BASE_URL = `${apiUrl}/api/2.0/user_roles`;
const WORKSPACE_USER_ROLE_BASE_URL = `${cleverstoryApiUrl}/api/2.0/workspaces/user-roles`


/**
 * Create User Role
*/
export const createUserRole = createAction(CREATE_USER_ROLE, (request, callback) => {
  return {
    request: request,
    callback: callback
  };
})

export const createUserRoleSucceeded = createAction(CREATING_USER_ROLE_SUCCEEDED, (response) => {
  return response;
})

export const createUserRoleFailed = createAction(CREATING_USER_ROLE_FAILED, (error) => {
  return error;
})

function* createUserRoleSaga(action) {
  const { request, callback } = action.payload;

  const createUserRoleAPI = () => {
    return axios.post(USER_ROLES_BASE_URL, request).then(response => response.data);
  }

  try {
    const response = yield call(createUserRoleAPI);
    if (response) {
      yield put(createUserRoleSucceeded(response));
      if(callback) {
        callback(response);
      }
    }
  } catch (error) {
    yield put(createUserRoleFailed(error));
  }
}


/**
 * Update User Role
*/
export const updateUserRole = createAction(UPDATE_USER_ROLE, (id, request) => {
  return {
    id: id,
    request: request
  }
})

export const updateUserRoleSucceeded = createAction(UPDATING_USER_ROLE_SUCCEEDED, (id, response) => {
  return {
    id: id,
    response: response
  }
})

export const updateUserRoleFailed = createAction(UPDATING_USER_ROLE_FAILED, (id, error) => {
  return {
    id: id,
    error: error
  }
})

function* updateUserRoleSaga(action) {
  const { id, request } = action.payload;

  let url = buildUrl(USER_ROLES_BASE_URL, {
    path: `/${id}`
  });

  const updateUserRoleAPI = () => {
    return axios.put(url, request).then(response => response.data);
  }

  try {
    const response = yield call(updateUserRoleAPI);
    if (response) {
      yield put(updateUserRoleSucceeded(response));
    }
  } catch (error) {
    yield put(updateUserRoleFailed(error));
  }
}

/**
* FETCH USER ROLES FOR WORKSPACE
*/
export const fetchUserRoles = createAction(FETCH_USER_ROLES);


const fetchUserRolesSucceeded = createAction(FETCH_USER_ROLES_SUCCEEDED, (response) => {
  return response;
})

const fetchUserRolesFailed = createAction(FETCH_USER_ROLES_FAILED, (error) => {
  return error;
})

function* fetchUserRolesSaga() {
  
  const url = `${WORKSPACE_USER_ROLE_BASE_URL}`;
  
  const fetchUserRolesAPI = () => {
    return axios.get(url).then(response => response.data);
  }

  try {
    const response = yield call(fetchUserRolesAPI);
    yield put(fetchUserRolesSucceeded(response));
  } catch (error) {
    yield put(fetchUserRolesFailed(error));
  }
}

/**
* FETCH USER ROLE FOR ACCOUNT
*/
export const fetchUserRole = createAction(FETCH_USER_ROLE, (id) => {
  return {
    id: id
  };
})

const fetchUserRoleSucceeded = createAction(FETCH_USER_ROLE_SUCCEEDED, (response) => {
  return response;
})

const fetchUserRoleFailed = createAction(FETCH_USER_ROLE_FAILED, (error) => {
  return error;
})

function* fetchUserRoleSaga(action) {
  const id = action.payload;

  const fetchUserRoleAPI = () => {
    return axios.get(`${USER_ROLES_BASE_URL}/${id}`).then(response => response.data);
  }

  try {
    const response = yield call(fetchUserRoleAPI);
    yield put(fetchUserRoleSucceeded(response));
  } catch (error) {
    yield put(fetchUserRoleFailed(error));
  }
}


/**
 * Delete User Role
*/
export const deleteUserRole = createAction(DELETE_USER_ROLE, (id) => {
  return id;
})

export const deleteUserRoleSucceeded = createAction(DELETING_USER_ROLE_SUCCEEDED, (id) => {
  return id;
})

export const deleteUserRoleFailed = createAction(DELETING_USER_ROLE_FAILED, (id, error) => {
  return {
    id: id,
    error: error
  }
})

function* deleteUserRoleSaga(action) {
  const id = action.payload;

  let url = buildUrl(USER_ROLES_BASE_URL, {
    path: id
  });

  const deleteUserRoleAPI = () => {
    return axios.delete(url).then(response => response.data);
  }

  try {
    yield call(deleteUserRoleAPI);
    yield put(fetchUserRolesSucceeded(id));
  } catch (error) {
    yield put(fetchUserRolesFailed(id, error));
  }
}



export default function* userRolesSaga() {
  yield takeLatest(CREATE_USER_ROLE, createUserRoleSaga);
  yield takeLatest(UPDATE_USER_ROLE, updateUserRoleSaga);
  yield takeLatest(FETCH_USER_ROLES, fetchUserRolesSaga);
  yield takeLatest(FETCH_USER_ROLE, fetchUserRoleSaga);
  yield takeLatest(DELETE_USER_ROLE, deleteUserRoleSaga);

};